import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

interface PublicRoutesProps {
  element: React.ReactNode;
}

const PublicRoutes: React.FC<PublicRoutesProps> = ({ element }) => {
  const { validateToken } = useAuth();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    const checkAuth = async () => {
      const isValid = await validateToken();
      setIsAuthenticated(isValid);
    };

    checkAuth();
  }, [validateToken]);

  if (isAuthenticated === null) return null;

  return isAuthenticated ? <Navigate to="/dashboard" /> : <>{element}</>;
};

export default PublicRoutes;
